import React, { useState, lazy, Suspense, useEffect } from "react";

import "../static/bootstrap-5.3.3-dist/css/bootstrap.min.css";

import { useTranslation } from "react-i18next";

const ModalRegister = lazy(() => import("../modal/modal_register.js"));
const ModalLogin = lazy(() => import("../modal/modal_login.js"));

function HeaderNoLogin({
    setIsLogged,
    setUserId,
    showRegisterModal,
    forceMobile,
    setForceMobile,
    setIsUserCashBlocked,
    setHomeReload,
}) {
    const { t } = useTranslation();
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleOpenRegisterModal = () => {
        setIsLoginModalOpen(false);
        setIsRegisterModalOpen(true);
    };

    useEffect(() => {
        if (showRegisterModal) {
            setIsRegisterModalOpen(true);
        }
    }, [showRegisterModal]);

    const handleOpenLoginModal = () => {
        setIsRegisterModalOpen(false);
        setIsLoginModalOpen(true);
    };

    const handleCloseModal = (modalType) => {
        setIsAnimating(true);
        setTimeout(() => {
            if (modalType === "register") {
                setIsRegisterModalOpen(false);
            } else if (modalType === "login") {
                setIsLoginModalOpen(false);
            } else {
                setIsRegisterModalOpen(false);
                setIsLoginModalOpen(false);
            }
            setIsAnimating(false);
        }, 300);
    };

    return (
        <nav className="headerTopNav navbar navbar-expand-lg navbar-light bg-light fixed-top">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img
                        src={`/assets/img/logo-desktop.png?ts=${new Date().getTime()}`}
                        alt="Nome-sito"
                    />
                </a>
                <div className="nav_account">
                    <ul className="nav">
                        {/* <li className="nav-item">
                        <a
                            href="#"
                            className="registration"
                            onClick={(e) => {
                            e.preventDefault();
                            handleOpenRegisterModal(); 
                            }}
                        >
                            {t('Sign_up')}
                        </a>
                        </li> */}
                        <li className="nav-item">
                            <a
                                href="#"
                                className="login_initial"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenLoginModal();
                                }}
                            >
                                {t("Login")}
                            </a>
                        </li>
                        {/* <li className="nav-item">
              <a className="assitence sb-chat-btn" href="javascript:SBChat.initChat();SBChat.open()">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style={{ enableBackground: 'new 0 0 512 512' }}
                  xmlSpace="preserve"
                >
                  <path d="M398.2,0H113.8C50.9,0,0,50.9,0,113.8v368.7c-0.1,2.3,0.1,4.5,0.5,6.7c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0.1,0.4,0.1,0.5c0.1,0.4,0.2,0.8,0.3,1.2c0,0,0,0,0,0C4.6,503.4,15.5,512,28.4,512c8.6,0,16.4-3.9,21.6-9.9l104-103.9h244.2c62.8,0,113.8-50.9,113.8-113.8V113.8C512,50.9,461.1,0,398.2,0z M455.1,284.5c-0.1,31.4-25.5,56.8-56.9,56.9h-256c-7.5,0-14.8,3-20.1,8.3l-65.2,65.1v-301C57,82.4,82.4,57,113.8,56.9h284.4c31.4,0.1,56.8,25.5,56.9,56.9V284.5z"></path>
                  <path d="M369.8,113.9H142.2c-15.7,0-28.4,12.7-28.4,28.4c0,15.6,12.7,28.4,28.4,28.4h227.6c15.7,0,28.4-12.7,28.4-28.4C398.2,126.6,385.5,113.9,369.8,113.9z"></path>
                  <path d="M312.9,227.6H142.2c-15.7,0-28.4,12.7-28.4,28.4s12.7,28.4,28.4,28.4h170.7c15.7,0,28.4-12.7,28.4-28.4S328.6,227.6,312.9,227.6z"></path>
                </svg>
              </a>
            </li> */}
                    </ul>
                </div>
            </div>

            {/* Показуємо модальні вікна */}
            {isRegisterModalOpen && (
                <Suspense fallback={<div>{t("loading")}...</div>}>
                    <ModalRegister
                        setIsLogged={setIsLogged}
                        show={isRegisterModalOpen && !isAnimating}
                        onClose={() => handleCloseModal("register")}
                        onOpenLoginModal={handleOpenLoginModal}
                        setIsUserCashBlocked={setIsUserCashBlocked}
                        setHomeReload={setHomeReload}
                    />
                </Suspense>
            )}

            {isLoginModalOpen && (
                <Suspense fallback={<div>{t("loading")}...</div>}>
                    <ModalLogin
                        setIsLogged={setIsLogged}
                        setUserId={setUserId}
                        show={isLoginModalOpen && !isAnimating}
                        onClose={() => handleCloseModal("login")}
                        onOpenRegisterModal={handleOpenRegisterModal}
                        setIsUserCashBlocked={setIsUserCashBlocked}
                        setHomeReload={setHomeReload}
                    />
                </Suspense>
            )}
        </nav>
    );
}

export default HeaderNoLogin;
